var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xl-12"
  }, [_vm.isPlanSwitchable ? _c('div', {
    staticClass: "notice notify-renewal"
  }, [_c('h2', [_vm._v("Open Enrollment Plan change Alert")]), _c('p', [_vm._v(" Your plan is eligible to change for Jan 1, 2026, you can keep your existing plan or choose to change to another plan. Deadline to change is 12/15/2025. If you do not choose a new plan, your current plan will renew at the renewal rate. ")]), _vm.loadingPlan ? _c('ul', {
    staticClass: "text-center mt-2"
  }, [_c('strong', [_vm._v("Loading...")])]) : _c('ul', [_c('dashboard-enrollment-current-plan', {
    attrs: {
      "current-plan": _vm.currentPlan
    },
    on: {
      "update:currentPlan": function ($event) {
        _vm.currentPlan = $event;
      },
      "update:current-plan": function ($event) {
        _vm.currentPlan = $event;
      }
    }
  }), _c('dashboard-enrollment-renew-plan', {
    attrs: {
      "current-plan": _vm.currentPlan
    },
    on: {
      "update:currentPlan": function ($event) {
        _vm.currentPlan = $event;
      },
      "update:current-plan": function ($event) {
        _vm.currentPlan = $event;
      },
      "renewalsStatus": function ($event) {
        return _vm.checkRenewalStatus();
      },
      "onSwitchedPlan": function ($event) {
        return _vm.getCurrentNewPlan();
      }
    }
  })], 1)]) : _vm._e(), _vm.hasActiveSolisticePlan ? _c('div', {
    staticClass: "notice notify-renewal"
  }, [_c('h2', [_vm._v("Plan Renewal Alert")]), _c('p', [_vm._v(" Your plan (" + _vm._s(_vm.currentPlan) + ") renewed on June 1, 2025, as of July 1, 2025 your current plan will be billed at the updated renewal rate. ")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }